import { Form, Input } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { EntTypeAnimal } from "../../../../models/handBooks/typeAnimal";
import { DraggableModal } from "../../../../components/DraggableModal";
import { SelectUnitMeasurement } from "../../../../components/selects";

enum FormField {
    nameKy,
    unitMeasurementId,
    nameRu
}
interface IProps {
    show: boolean;
    typeAnimal: EntTypeAnimal;
    onHide: () => void;
    onSubmit: (pos: EntTypeAnimal) => Promise<boolean>;
}

export const AddTypeAnimalModal = (props: IProps) => {
    const { t } = useTranslation();
    const [form] = useForm();
    const [loading, setLoading] = useState<boolean>(false);


    useEffect(() => {
        if (props.show) setFieldsFromEntity();
    }, [props.show]);


    const setFieldsFromEntity = (): void => {
        form.setFields([
            { name: FormField.unitMeasurementId, value: props.typeAnimal.unitMeasurement?.id },
            { name: FormField.nameKy, value: props.typeAnimal.nameKy },
            { name: FormField.nameRu, value: props.typeAnimal.nameRu },
        ]);
    }

    const setEntityFromFields = (): EntTypeAnimal => {
        let typeAnimal = _.cloneDeep(props.typeAnimal);
        typeAnimal.unitMeasurementId = form.getFieldValue(FormField.unitMeasurementId);
        typeAnimal.nameKy = form.getFieldValue(FormField.nameKy);
        typeAnimal.nameRu = form.getFieldValue(FormField.nameRu);
        return typeAnimal;
    }

    const handleSubmit = async () => {
        setLoading(true);
        try {
            await form.validateFields();
            const data = setEntityFromFields();
            const result = await props.onSubmit(data);

            if (result) props.onHide();
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <DraggableModal
                title={props.typeAnimal.id === 0 ? t('handbooks.animal_species.add_animal_species') : t('handbooks.animal_species.edit_animal_species')}
                visible={props.show}
                onCancel={props.onHide}
                onSubmit={handleSubmit}
                submitLoading={loading}
            >
                <Form
                    initialValues={{ remember: true }}
                    autoComplete="off"
                    layout="vertical"
                    form={form}
                >
                    <Form.Item
                        label={t('general.nameKy')}
                        name={FormField.nameKy}
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <Input autoComplete="off" />
                    </Form.Item>
                    <Form.Item
                        label={t('general.nameRu')}
                        name={FormField.nameRu}
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <Input autoComplete="off" />
                    </Form.Item>
                    <Form.Item
                        label={t('titles.units_of_measurement')}
                        name={FormField.unitMeasurementId}
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <SelectUnitMeasurement measurementCategoryAlias='count'/>
                    </Form.Item>
                </Form>
            </DraggableModal>

        </>

    )
}
